import React, { Fragment } from 'react';

import FormikTextField, { FormikTextFieldProps } from './FormikTextField';
import MuiTextField, { MuiTextFieldProps } from './MuiTextField';
import MuiSelect, { MuiSelectProps } from './MuiSelect';
import MuiDatePicker, { MuiDatePickerProps } from './MuiDatePicker';
import MuiCheckbox, { MuiCheckboxProps } from './MuiCheckbox';

//PM 2021-04-30
export interface FormField {
    props: FormikTextFieldProps | MuiTextFieldProps | MuiSelectProps | MuiDatePickerProps | MuiCheckboxProps,
    type: FieldTypes,
    hidden?: boolean,
}

export interface FormFields {
    inline?: FormField[],
    block?: FormField,
}

//PM 2021-04-30
export enum FieldTypes {
    text,
    formikText,
    select,
    date,
    checkbox,
}

//PM 2021-04-30
function renderField(field: FormField): JSX.Element | null {
    let returnField: JSX.Element | null = null;

    if (!field.hidden)
        if (field.type === FieldTypes.text) {
            const props = field.props as MuiTextFieldProps;
            returnField = (<MuiTextField {...props} />);
        }
        else if (field.type === FieldTypes.formikText) {
            const props = field.props as FormikTextFieldProps;
            returnField = (<FormikTextField {...props} />);
        }
        else if (field.type === FieldTypes.select) {
            const props = field.props as MuiSelectProps;
            returnField = (<MuiSelect {...props} />);
        }
        else if (field.type === FieldTypes.date) {
            const props = field.props as MuiDatePickerProps;
            returnField = (<MuiDatePicker {...props} />);
        }
        else if (field.type === FieldTypes.checkbox) {
            const props = field.props as MuiCheckboxProps;
            returnField = (<MuiCheckbox {...props} />);
        }

    return returnField;
}

export function renderFields(fields: FormFields[]): Array<JSX.Element | null> {
    return fields
        .map(fields => fields.inline
            ? (
                <Fragment key={fields.inline[0].props.key}>
                    {fields.inline.map(field => renderField(field))}
                </Fragment>
            ) : fields.block ? renderField(fields.block) : null);
}